import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import type { Constructor } from '@whispli/types';

export class __LandingPageExtraFeatureFlags extends ResponseBody {
}
export type LandingPageExtraFeatureFlags = Omit<__LandingPageExtraFeatureFlags, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual'>
export const LandingPageExtraFeatureFlags = __LandingPageExtraFeatureFlags as any as Constructor<LandingPageExtraFeatureFlags>
